import { API } from '@aws-amplify/api'
import { useMutation, UseMutationResult } from 'react-query'
import * as Sentry from '@sentry/nextjs'

type Response = {
  savedListingId: number
  listingRemoved: boolean | undefined
}

const saveFavorite = async (
  listingId: number,
  remove?: boolean
): Promise<Response> => {
  try {
    await API.post(
      'customer',
      `/listings/${listingId}/favorite`,
      remove
        ? {
            queryStringParameters: {
              remove: true,
            },
          }
        : {}
    )

    return { savedListingId: listingId, listingRemoved: remove }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    Sentry.captureException(error)
    throw new Error(error.response?.data?.message || 'Something went wrong')
  }
}

type Params = {
  listingId: number
  remove?: boolean
}

export const useSaveFavorite = (): UseMutationResult<
  Response,
  Error,
  Params,
  unknown
> => {
  return useMutation('saveFavorite', ({ listingId, remove }: Params) =>
    saveFavorite(listingId, remove)
  )
}
